import React from 'react';
import * as yup from 'yup';
import { Field, Formik } from 'formik';
import { Button } from '../../catalyst/core';
import FormikTextField from '../../catalyst/core/form/TextField/variants/FormikTextField';
import * as Icon from 'react-feather';
import { Divider, Grid, IconButton, Tooltip } from '@material-ui/core';
import uuidAPIKey from 'uuid-apikey';
import { CopyToClipboard } from 'react-copy-to-clipboard/lib/Component';

const textField = {
    id: 'apiKey',
    label: 'API Key',
    name: 'apiKey',
    type: 'text',
    component: 'FormikTextField',
    disabled: true,
    xs: 12,
    sm: 12,
    md: 12,
    fullWidth: true,
};

const ApiKeyForm = ({ validationSchema, initialValues, submit }) => {
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting, setValues }) => {
                submit(values, setSubmitting, setValues);
            }}
            validationSchema={yup.object(validationSchema)}
        >
            {({ submitForm, isSubmitting, errors, touched, values }) => (
                <form
                    onSubmit={(event) => {
                        event.preventDefault();
                        submitForm();
                    }}
                >
                    <Divider style={{ marginBottom: '10px' }} />
                    <Grid
                        container
                        direction="row"
                        alignItems="flex-end"
                        spacing={1}
                    >
                        <Grid item width={'200px'}>
                            <Field
                                id={'generate'}
                                label={'generate'}
                                name={'generate'}
                            >
                                {({ field, form: { setFieldValue } }) => {
                                    const onChange = () => {
                                        setFieldValue(
                                            'apiKey',
                                            uuidAPIKey.create().apiKey
                                        );
                                    };
                                    return (
                                        <Button
                                            onClick={onChange}
                                            style={{
                                                marginBottom: '10px',
                                                height: '38px',
                                                lineHeight: '38px',
                                            }}
                                            variant={'contained'}
                                            color={'secondary'}
                                        >
                                            Generate API Key
                                        </Button>
                                    );
                                }}
                            </Field>
                        </Grid>
                        <Grid item xs={7}>
                            <FormikTextField {...textField} />
                        </Grid>
                        <Grid item width={'80px'}>
                            <Tooltip title="Copy to Clipboard" placement="top">
                                <CopyToClipboard text={values.apiKey}>
                                    <IconButton
                                        style={{
                                            marginBottom: '10px',
                                            height: '38px',
                                            lineHeight: '38px',
                                        }}
                                        onClick={() => {}}
                                    >
                                        <Icon.Copy size={20} />
                                    </IconButton>
                                </CopyToClipboard>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Divider style={{ marginBottom: '10px' }} />
                    <Grid container direction="row" justifyContent="flex-end">
                        <Button
                            type="submit"
                            variant={'contained'}
                            color={'primary'}
                        >
                            Save Api Key
                        </Button>
                    </Grid>
                </form>
            )}
        </Formik>
    );
};

export default ApiKeyForm;
